import React, {useState} from 'react'

const Subscribe = () => {
  const [isSubscribed, setSubscribed] = useState(false);
  const [type, setType] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = event => {
    event.preventDefault();

    if (['women', 'men', 'both'].indexOf(type) > -1 && /\S+@\S+\.\S+/.test(email)) {
      setSubscribed(true)
    }
  };

  return (
    <div className="subscribe__wrapper">
      <h2 className="subscribe__title">подписаться на рассылку выгодных предложений</h2>
      {isSubscribed ? (<div className="subscribe__success"><p>Подписка оформлена! Спасибо!</p></div>) :
        (<form className="subscribe__radios" onSubmit={handleSubmit}>
          <label className="subscribe__radio_label">
            <input className="subscribe__radio" type="radio" name="subscribe" value="women"
                   onClick={event => setType(event.target.value)}/>
            <div className="subscribe__radio_text">Женское</div>
          </label>
          <label className="subscribe__radio_label">
            <input className="subscribe__radio" type="radio" name="subscribe" value="men"
                   onClick={event => setType(event.target.value)}/>
            <div className="subscribe__radio_text">Мужское</div>
          </label>
          <label className="subscribe__radio_label">
            <input className="subscribe__radio" type="radio" name="subscribe" value="both"
                   onClick={event => setType(event.target.value)}/>
            <div className="subscribe__radio_text">Всё</div>
          </label>
          <input className="subscribe__email" type="email" placeholder="Ваш e-mail" value={email}
                 onChange={event => setEmail(event.target.value)}/>
          <input className="subscribe__submit" type="submit" value="ПОДПИСАТЬСЯ"/>
        </form>)
      }
    </div>
  )
};

export default Subscribe
